import {Button, Collapse, FormControl, Input, InputLabel, Typography} from "@mui/material";
import {Box} from "@mui/system";
import {FC, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useAuth} from "../../firebase/firebaseAuth";
import i18n from "i18next";

type LoginPassword = {
  password: string
  repeatPassword: string
  email: string
}
type Props = {
  privacyPolicyAccepted: boolean
  setPrivacyPolicyError: () => void
}
export const CustomLogin: FC<Props> = ({privacyPolicyAccepted, setPrivacyPolicyError}) => {
  const {t} = useTranslation();

  const {signIn, register, resetPassword} = useAuth();
  const [loginPassword, setLoginPassword] = useState<LoginPassword>({password: "", repeatPassword: "", email: ""})
  const [error, setError] = useState<string | null>(null);
  const [option, setOption] = useState<"login" | "register" | "resetPassword">("login")
  useEffect(() => {
    if (privacyPolicyAccepted) {
      setError(null)
    }
  }, [privacyPolicyAccepted])
  const handleForm = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (emailValidation(loginPassword.email)) {
      if (option === "resetPassword") {
        resetPassword(loginPassword.email)
      } else {
        validatePasswordsAndHandleSubmit()
      }
    } else {
      setError(t('login.error.wrongEmail') || "")
    }
  }
  const validatePasswordsAndHandleSubmit = () => {
    if (passwordValidation(loginPassword.password)) {
      if (privacyPolicyAccepted) {
        if (option === "login") {
          signIn(loginPassword.email, loginPassword.password).catch((e) => setError(t('login.error.wrongEmailOrPassword') || ""))
        } else {
          if (loginPassword.password === loginPassword.repeatPassword) {

            register(loginPassword.email, loginPassword.password).catch(
              (e) => {
                if (e.code === "auth/email-already-in-use") {
                  setError(t('login.error.emailInUse') || "")
                } else {
                  setError(t('login.error.unknown') || "")
                }
              }
            )

          } else {
            setError(t('login.error.passwordsNotMatch') || "")
          }
        }
      } else {
        setError(t('login.option.privacy.error') || "")
        setPrivacyPolicyError()
      }
    } else {
      setError(t('login.error.passwordRequirements') || "error")
    }
  }

  const getSubmitButtonText = () => {

    if (option === "login") {
      return t('login.login')
    } else if (option === "register") {
      return t('login.register')
    } else if (option === "resetPassword") {
      return t('login.forgottenPassword')
    }
  }

  return (
    <form onSubmit={(e) => handleForm(e)}>
      <Box display="flex" flexDirection="column" gap={2} alignItems="center" mt={2}>

        <FormControl>
          <InputLabel htmlFor="email">{t('login.email')}</InputLabel>
          <Input type="email" id="email" aria-describedby="email-helper-text"
                 onChange={(e) => setLoginPassword({...loginPassword, email: e.target.value})}/>
        </FormControl>
        <Collapse in={option !== "resetPassword"}>
          <Box display="flex" flexDirection="column" gap={2} alignItems="center">
            <FormControl>
              <InputLabel htmlFor="password">{i18n.t('login.password')}</InputLabel>
              <Input type="password" id="password" aria-describedby="password-helper-text"
                     onChange={(e) => setLoginPassword({...loginPassword, password: e.target.value})}/>
            </FormControl>
            <Collapse in={option === "register"}>
              <FormControl>
                <InputLabel htmlFor="repeatPassword">{t('login.repeatPassoword')}</InputLabel>
                <Input type="password" id="repeatPassword" aria-describedby="repeatPassword-helper-text"
                       onChange={(e) => setLoginPassword({...loginPassword, repeatPassword: e.target.value})}/>
              </FormControl>
            </Collapse>
          </Box>
        </Collapse>
        <Typography color="error">{error}</Typography>
        <Button variant="contained" type="submit">{getSubmitButtonText()}</Button>

        <Box>
          {option !== "login" && <Button size="small" color="secondary" variant="text"
                                         onClick={() => setOption("login")}>{t('login.login')}</Button>}
          {option !== "register" && <Button size="small" color="secondary" variant="text"
                                            onClick={() => setOption("register")}>{t('login.register')}</Button>}
          {option !== "resetPassword" && <Button size="small" color="secondary" variant="text"
                                                 onClick={() => setOption("resetPassword")}>{t('login.forgottenPassword')}</Button>}
        </Box>
      </Box>
    </form>
  )

}
const emailValidation = (email: string): boolean => /(.+)@(.+){2,}\.(.+){2,}/.test(email)

const passwordValidation = (password: string): boolean => /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d\w\W]{8,}$/.test(password)